import React from "react";

/**
 * White card container for form pages: a flat sheet on the paper ground
 * (hairline edge, no resting shadow — DESIGN.md Elevation).
 *
 * Props:
 *   maxWidth – number | string  (default 640)
 *   maxHeight – number | string  (default 640)
 *   children – node
 */
function FormCard({ maxWidth = 640, maxHeight, style = {}, className = "", children, ...props }) {
    return (
        <div 
            className={`form-card${maxHeight ? " form-card--capped" : ""} ${className}`}
            {...props}
            style={{
                background: "#fff",
                borderRadius: "var(--radius-menu)",
                border: "1px solid var(--border)",
                padding: "1.5rem",
                maxWidth,
                maxHeight,
                overflowX: maxHeight ? "auto" : "visible",
                overflowY: maxWidth ? "auto" : "visible",
                margin: "0 auto",
                display: "flex",
                flexDirection: "column",
                ...style
            }}
        >
            {children}
        </div>
    );
}

export default FormCard;
